import RequestFailed from "./alerts/RequestFailed";
import React from "react";
import PropTypes from "prop-types";

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }


    render() {
        if (this.state.hasError) {
            return <RequestFailed />;
        }

        return this.props.children;
    }
}

ErrorBoundary.propTypes = {
    children: PropTypes.array.isRequired,
};

export default ErrorBoundary;
